import type { AuditItem, AuditState, GetterClass } from '../../../models'

export class DataGetter implements GetterClass {
  static execute(this: void, state: AuditState): AuditItem[] {
    return state.data
  }
}
